import React from "react";
import PropTypes from "prop-types";
import Translate from "react-translate-component";
import { Button } from "bitshares-ui-style-guide";
import counterpart from "counterpart";
export default function AccountBlockSelection(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "account-block-registration",
    onClick: props.onChangeActive
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-bg-block show-for-small-only"
  }, /*#__PURE__*/React.createElement("span", {
    className: "content"
  })), /*#__PURE__*/React.createElement(Translate, {
    content: "registration.securityKey",
    component: "p",
    className: `model-option security-key ${!props.active ? "inactive-text" : ""}`
  }), /*#__PURE__*/React.createElement(Translate, {
    content: "registration.securityAccountModel",
    component: "p",
    className: `model-option-value account-security option-border ${!props.active ? "inactive-text" : ""}`
  }), /*#__PURE__*/React.createElement(Translate, {
    content: "registration.loginByKey",
    component: "p",
    className: `model-option ${!props.active ? "inactive-text" : ""}`
  }), /*#__PURE__*/React.createElement(Translate, {
    content: "registration.accountLoginByValue",
    component: "p",
    className: `model-option-value account-option-value option-border ${!props.active ? "inactive-text" : ""}`
  }), /*#__PURE__*/React.createElement(Translate, {
    content: "registration.backUpRestoreKey",
    component: "p",
    className: `model-option ${!props.active ? "inactive-text" : ""}`
  }), /*#__PURE__*/React.createElement(Translate, {
    content: "settings.no",
    component: "p",
    className: `model-option-value account-option-value ${!props.active ? "inactive-text" : ""}`
  }), props.active ? /*#__PURE__*/React.createElement(Button, {
    onClick: props.onSelect,
    type: "primary"
  }, counterpart.translate("registration.continue")) : /*#__PURE__*/React.createElement(Button, null, counterpart.translate("registration.select")));
}
AccountBlockSelection.propTypes = {
  active: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onChangeActive: PropTypes.func.isRequired
};